import { Loadable } from '@gdp/react-app/lib/helpers/loadable';

export const LoadableDriverFeeRoutes = Loadable(
  './DriverFeeRoutes',
  () => import(/* webpackChunkName: "DriverFee" */ './DriverFeeRoutes'),
  () => [(require as any).resolveWeak('./DriverFeeRoutes')]
);
